

























































































































import { Component, Mixins } from 'vue-property-decorator'
import { projectStore } from '@/store/session/ProjectStoreModule'
import {
  TCWBaseError,
} from '@/plugins/TCWBaseError'
import {
  ApiGeneralObjectArrayPayload,
  ApiGeneralSinglePayload,
  ApiPayloadValueType,
  CodeLabel
} from '@/tcw/api/types'
import * as ApiPath from '@/tcw/constant/ApiPath'
import Jikan from '@/tcw/domain/Jikan'
import KintaiPatternCard from '@/components/pattern/molecules/KintaiPatternCard.vue'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { IFormStore, Project } from '@/store/types'

class ProjectFormStoreComponent extends FormStoreComponent<Project> {}

@Component({
  components: { KintaiPatternCard }
})
export default class ProjectSetteiForm extends Mixins(ProjectFormStoreComponent) {
  private isFirstLogin = false
  private isCalculating = false
  private kintaiPatternList: ApiGeneralObjectArrayPayload = []

  get formName(): string {
    return 'projectForm'
  }
  get storeModule(): IFormStore<Project> {
    return projectStore
  }

  get form(): Project | null {
    return projectStore.editData !== null ? projectStore.editData : null
  }

  get kaishiValue(): Jikan {
    if (typeof this.form?.teijiKaishiJikoku !== 'string') {
      return new Jikan(9, 0)
    }
    const jikan = Jikan.generateByJikanStr(this.form.teijiKaishiJikoku)
    return jikan ? jikan : new Jikan(9, 0)
  }
  set kaishiValue(newJikan: Jikan) {
    const updateValue = newJikan.toString()
    this.updateValue('teijiKaishiJikoku', updateValue)
    this.updateValue('teijiJikan', updateValue === null || this.shuryoValue === null ? null : 'OK')
  }

  get shuryoValue(): Jikan {
    if (typeof this.form?.teijiShuryoJikoku !== 'string') {
      return new Jikan(18, 0)
    }
    const jikan = Jikan.generateByJikanStr(this.form.teijiShuryoJikoku)
    return jikan ? jikan : new Jikan(18, 0)
  }
  set shuryoValue(newJikan: Jikan) {
    const updateValue = newJikan.toString()
    this.updateValue('teijiShuryoJikoku', updateValue)
    this.updateValue('teijiJikan', this.kaishiValue === null || updateValue === null ? null : 'OK')
  }

  get kintaiPatternOptions(): CodeLabel[] {
    return this.kintaiPatternList.map(pattern => {
      if (!pattern || typeof pattern !== 'object') {
        return { code: '', label: '' }
      }
      return {
        code: Number(pattern.id),
        label: `${pattern.patternName}`
      }
    })
  }
  get kintaiPattern(): ApiGeneralSinglePayload | null {
    if (!this.form?.kintaiPatternId) {
      return null
    }
    const pattern = this.kintaiPatternList.find(
      (p: ApiGeneralSinglePayload) => String(p.id) === String(this.form?.kintaiPatternId)
    )
    return pattern ? pattern : null
  }
  get shoteiRoudouJikanStr(): string {
    if (!this.form?.shoteiRoudouJikan) {
      return '-'
    }
    let shoteiRoudouJikan = this.form.shoteiRoudouJikan
    if (typeof shoteiRoudouJikan !== 'number') {
      return '-'
    }
    return `${(shoteiRoudouJikan / 60).toFixed(2)}H`
  }

  private inputKyukei(fieldName: string, updateValue: ApiPayloadValueType): void {
    this.updateValue(fieldName, updateValue)
    this.calcShoteiRoudouJikan()
  }

  private async calcShoteiRoudouJikan(): Promise<void> {
    if (this.isLoading) {
      return
    }
    try {
      this.isCalculating = true
      const path = ApiPath.Paths.ProjectCalc.shotei
      const form = (this.form as unknown) as ApiGeneralSinglePayload
      const response = await this.getWebApi().call<number>(path, 'POST', form)
      if (typeof response === 'number') {
        this.updateValue('shoteiRoudouJikan', response)
      }
    } catch (e) {
      console.error('所定労働時間の計算に失敗', e)
      this.updateValue('shoteiRoudouJikan', null)
    } finally {
      this.isCalculating = false
    }
  }

  protected async beforeProc(): Promise<void> {
    // プロジェクト設定後に値が更新されてしまうので、最初に取っておく
    this.isFirstLogin = this.isFirstLoginFlow
  }

  // プロジェクト情報の読み込みはログイン時に行うため、空回しにする
  protected async loadStore(): Promise<void> {
    return
  }

  protected async fetchKintaiPatternList(): Promise<void> {
    try {
      const response = await this.getWebApi().call<ApiGeneralObjectArrayPayload>(
        ApiPath.Paths.KintaiPatternList.get,
        'GET'
      )
      this.kintaiPatternList = response
    } catch (e) {
      // 非同期の為、errorProcを自前で呼ぶ
      if (e instanceof TCWBaseError) {
        await this.errorProc(e)
      }
    }
  }
  
  protected async afterProc(): Promise<void> {
    this.updateValue(
      'teijiJikan',
      this.kaishiValue === null || this.shuryoValue === null ? null : 'OK'
    )
    this.fetchKintaiPatternList()
  }

  protected async afterSaveProc(): Promise<void> {
    this.clearForm()

    await projectStore.fetch()

    // 画面遷移
    if (this.isFirstLogin) {
      // 初回ログイン時は承認ルート設定画面へ
      this.$tcw.message({
        type: 'success',
        message: 'プロジェクト情報を設定しました。続いて承認ルートの設定を行ってください。'
      })
      this.goto('/settei/shounin/route')
    } else {
      this.$tcw.message({
        type: 'success',
        message: 'プロジェクト情報を設定しました'
      })
      this.back()
    }
  }

  protected reset(): void {
    projectStore.reset()
  }
}
